/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeDTO } from './AttributeDTO';
import {
    AttributeDTOFromJSON,
    AttributeDTOFromJSONTyped,
    AttributeDTOToJSON,
} from './AttributeDTO';

/**
 * 
 * @export
 * @interface QueryAttributesExperimentResultDTO
 */
export interface QueryAttributesExperimentResultDTO {
    /**
     * 
     * @type {Array<AttributeDTO>}
     * @memberof QueryAttributesExperimentResultDTO
     */
    attributes: Array<AttributeDTO>;
    /**
     * Deprecated internal run UUID; use runCustomId instead
     * @type {string}
     * @memberof QueryAttributesExperimentResultDTO
     */
    experimentId: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAttributesExperimentResultDTO
     */
    experimentShortId: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAttributesExperimentResultDTO
     */
    organizationName: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAttributesExperimentResultDTO
     */
    projectName: string;
    /**
     * Preferred run custom identifier
     * @type {string}
     * @memberof QueryAttributesExperimentResultDTO
     */
    runCustomId?: string;
}

/**
 * Check if a given object implements the QueryAttributesExperimentResultDTO interface.
 */
export function instanceOfQueryAttributesExperimentResultDTO(value: object): value is QueryAttributesExperimentResultDTO {
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    if (!('experimentId' in value) || value['experimentId'] === undefined) return false;
    if (!('experimentShortId' in value) || value['experimentShortId'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('projectName' in value) || value['projectName'] === undefined) return false;
    return true;
}

export function QueryAttributesExperimentResultDTOFromJSON(json: any): QueryAttributesExperimentResultDTO {
    return QueryAttributesExperimentResultDTOFromJSONTyped(json, false);
}

export function QueryAttributesExperimentResultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryAttributesExperimentResultDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributes': ((json['attributes'] as Array<any>).map(AttributeDTOFromJSON)),
        'experimentId': json['experimentId'],
        'experimentShortId': json['experimentShortId'],
        'organizationName': json['organizationName'],
        'projectName': json['projectName'],
        'runCustomId': json['runCustomId'] == null ? undefined : json['runCustomId'],
    };
}

export function QueryAttributesExperimentResultDTOToJSON(value?: QueryAttributesExperimentResultDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributes': ((value['attributes'] as Array<any>).map(AttributeDTOToJSON)),
        'experimentId': value['experimentId'],
        'experimentShortId': value['experimentShortId'],
        'organizationName': value['organizationName'],
        'projectName': value['projectName'],
        'runCustomId': value['runCustomId'],
    };
}

